import React from 'react'
import { map, join, times, isBlank } from 'lodash'
import axios from 'lib/axios'
import { ListGroup, Row, Col, Button } from 'react-bootstrap'

import Icon from 'UI/FontAwesomeIcon'
import CopyButton from 'UI/CopyButton'

const hiddenString = (secret) => `${join(times(secret.length - 4, () => '#'), '')} ${secret.substring(secret.length - 4, secret.length)}`
const apiLastAccessedAt = (apiSecret) => {
  if (isBlank(apiSecret.last_accessed_at)) { return <span>Has not been accessed.</span> }

  return <span>{new Date(apiSecret.last_accessed_at).toLocaleString()}</span>
}

const APIAuth = ({ secrets = [], removeSecret, updateAlert, updateASecret }) => {
  if (secrets.length === 0) { return 'There are no API secrets associated with your account.' }
  const destroyApiSecret = (secret) => {
    if (confirm('Are you sure you want to destroy this secret?')) {
      axios.delete(`/api/authorization/${secret.id}`)
        .then((response) => {
          removeSecret(secret)
          updateAlert({ show: true, variant: 'primary', text: 'API secret destroyed.' })
        })
    }
  }

  return (
    <ListGroup>
      {map(secrets, apiSecret => (
        <ListGroup.Item>
          <Row>
            <Col>
              <ul className='list-unstyled'>
                <li><strong>{apiSecret.name}</strong></li>
                <li>Client ID: {apiSecret.uid} <CopyButton text={apiSecret.uid} /></li>
                <li>
                  Client Secret: {apiSecret.showSecret ? apiSecret.secret : hiddenString(apiSecret.secret)}
                  {' '}
                  <Icon
                    className='mr-2'
                    onClick={() => updateASecret(map(secrets, secret => secret === apiSecret ? { ...secret, showSecret: !apiSecret.showSecret } : secret))}
                    icon={apiSecret.showSecret ? 'eye-slash' : 'eye'}
                  />
                  <CopyButton text={apiSecret.secret} />
                </li>
                <li>Added on {new Date(apiSecret.created_at).toDateString()}</li>
                <li>Last used: {apiLastAccessedAt(apiSecret)}</li>
              </ul>
            </Col>
            <Col xs='3'>
              <Button onClick={() => destroyApiSecret(apiSecret)} variant='outline-danger'>
                <Icon icon='fire-alt' type='light' />
                {' '}
                Burn this secret
              </Button>
            </Col>
          </Row>
        </ListGroup.Item>
      ))}
    </ListGroup>
  )
}

export default APIAuth
